// services/api.js
import axios from "axios";

const API_BASE_URL =
  import.meta.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Clear auth and redirect to login
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      window.location.href = "/#/login";
    }

    return Promise.reject(error);
  }
);

// Auth API calls
export const authAPI = {
  login: async (credentials) => {
    const response = await apiClient.post("/auth/login", credentials);
    return response.data;
  },

  logout: async () => {
    const response = await apiClient.post("/auth/logout");
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await apiClient.get("/auth/me");
    return response.data;
  },
};

// Analytics API calls
export const analyticsAPI = {
  getRouteAnalyticsSummary: async (params) => {
    const response = await apiClient.get("/analytics/route/summary", { params });
    return response.data;
  },

  getJourneyAnalytics: async (legId) => {
    const response = await apiClient.get(`/analytics/journey/${legId}`);
    return response.data;
  },

  getSimilarRoutes: async (params) => {
    const response = await apiClient.get("/analytics/routes/similar", { params });
    return response.data;
  },

  getTollPlazaAnalytics: async (params) => {
    const response = await apiClient.get("/analytics/toll-plazas", { params });
    return response.data;
  },

  triggerJourneyProcessing: async (legId) => {
    const response = await apiClient.post(`/analytics/journey/process/${legId}`);
    return response.data;
  },

  triggerTollClustering: async () => {
    const response = await apiClient.post("/analytics/toll-plazas/cluster");
    return response.data;
  },
};

export default apiClient;
